import NewTag from "@/assets/images/NewTag";
import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import { COLORS } from "@/shared/constants/colors";
import Amplitude from "@/shared/services/amplitude.service";
import {
  getCurrentURL,
  getReferrer,
  getScreenWidth,
} from "@/shared/utils/commons";
import { getUTMFieldsFromLocalStorage } from "@/shared/utils/utm.util";
import { faCaretDown } from "@fortawesome/pro-light-svg-icons";
import {
  faCaretDown as faCaretDownSolid,
  faCaretUp,
} from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@graphy/ui";
import { ControlledMenu, MenuItem, useClick } from "@szhsin/react-menu";
// import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";

interface SubMenuProps {
  label: string;
  handleToggle: () => void;
  // isOpen: boolean;
  // onClose: () => void;
  menuItems: {
    name: string;
    link?: string;
    isNew?: boolean;
  }[];
}

export const NavbarMenu = ({
  label,
  menuItems,
  handleToggle,
}: SubMenuProps) => {
  const router = useRouter();
  const [showHoverIcon, setShowHoverIcon] = useState(false);

  const handleClick = (itemName: string) => {
    const { current_url, screen_width, referrer, item_name, utm_params } =
      LANDING_PAGE_EVENTS.NAV_ITEM_TAPPED.PROPERTIES;

    new Amplitude().sendEvent({
      type: LANDING_PAGE_EVENTS.NAV_ITEM_TAPPED.LABEL,
      properties: {
        [current_url]: getCurrentURL(),
        [screen_width]: getScreenWidth(),
        [referrer]: getReferrer(),
        [utm_params]: getUTMFieldsFromLocalStorage(),
        [item_name]: itemName,
      } as { [key: string]: string },
    });
    // onClose();
  };
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const anchorProps = useClick(isOpen, setOpen);

  useEffect(() => {
    if (isOpen) {
      handleToggle();
    }
  }, [isOpen, handleToggle]);
  return (
    <>
      <div
        className={`flex cursor-pointer  items-center justify-center text-caption font-normal hover:text-sapphire02 ${
          isOpen ? "text-purple-4" : "text-grey-3"
        }`}
        {...anchorProps}
        ref={ref}
        onMouseOver={() => {
          setShowHoverIcon(true);
        }}
        onMouseLeave={() => {
          setShowHoverIcon(false);
        }}
      >
        <button>{label}</button>
        {showHoverIcon && !isOpen ? (
          <Icon
            icon={faCaretDownSolid}
            className="ml-1"
            color={COLORS.SAPPHIRE_02}
            width={16}
            height={16}
          />
        ) : (
          <Icon
            icon={!isOpen ? faCaretDown : faCaretUp}
            width={16}
            height={16}
            className="ml-1"
            color={isOpen ? COLORS.PURPLE_04 : COLORS.GREY_03}
          />
        )}
      </div>
      <ControlledMenu
        state={isOpen ? "open" : "closed"}
        anchorRef={ref}
        onClose={() => setOpen(false)}
      >
        {
          <ul
            className={`  md:grid ${
              isOpen ? "visible opacity-100" : "invisible opacity-0"
            } ${
              menuItems.length <= 4
                ? "-left-10 grid-cols-1"
                : "-left-[13rem] grid-cols-2"
            } bottom-shadow-purple absolute  top-6 grid w-max  gap-x-6 gap-y-4  rounded-3xl border border-purple-2 bg-white p-6 transition-opacity ease-in`}
          >
            {menuItems.map((item, index) => {
              return (
                <MenuItem key={item.name + item.link + index}>
                  <div
                    className={`w-fit  cursor-default text-body font-medium text-grey-4 `}
                  >
                    <>
                      {item?.link && (
                        <Link
                          href={item.link}
                          onClick={() => handleClick(item.name)}
                          prefetch={false}
                        >
                          {item.name}
                          {item.isNew && (
                            <span className="ml-1 inline-flex">
                              <NewTag
                                width={28}
                                height={14}
                                className="inline-block"
                              />
                            </span>
                          )}
                        </Link>
                      )}
                    </>
                  </div>
                </MenuItem>
              );
            })}
          </ul>
        }
      </ControlledMenu>
    </>
  );
};
